import axios from 'axios';

const IMAGE_URL = process.env.REACT_APP_IMAGE_URL || '';

// Same bug class as unitMaster/unitImageHelpers.js and the customer-document
// preview: a saved image's fullUrl/imagePath is used as-is in a plain
// <img src>. That request carries none of this app's auth headers (those
// only get attached by the axios interceptor), so anything but a fully
// public file 401s silently and the <img> just renders broken/blank.
const LOCALHOST_ORIGIN_PATTERN = /^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?/i;

export const rewriteLocalhostImageUrl = (url) => {
  if (!url || !IMAGE_URL || !LOCALHOST_ORIGIN_PATTERN.test(url)) return url;
  try {
    const targetOrigin = new URL(IMAGE_URL).origin;
    return url.replace(LOCALHOST_ORIGIN_PATTERN, targetOrigin);
  } catch {
    return url;
  }
};

// Detect image vs. non-image so the caller can pick <img> vs. <iframe> - a
// plain <img> silently renders blank for anything a browser can't decode as
// an image (a PDF, most obviously) even once the blob itself was fetched.
export const isPropertyImageFile = (row, url = '') => {
  if (row?.file instanceof File) {
    return row.file.type.startsWith('image/');
  }
  return /\.(jpe?g|png|gif|webp|bmp|svg)$/i.test(url || row?.fileName || row?.originalFileName || '');
};

export const fetchAuthenticatedImageBlob = async (url) => {
  const token = localStorage.getItem('Token');
  const db = localStorage.getItem('DataBase');
  const response = await axios.get(url, {
    responseType: 'blob',
    headers: {
      apikey: 'V+kBloEwqqVho1PINmQI0VJQwSBX2l/e',
      Authorization: `Bearer ${token}`,
      db,
    },
  });
  return response.data;
};
